module.exports = __webpack_public_path__ + "static/media/04_BOJO_MEIA_TACA_ESTAMPADO_13.f750a7ed.jpg";